const calcTouchzoneSide = ({
  containerRect,
  popoverRect,
  direction
}) => {
  const {
    width: containerWidth,
    height: containerHeight
  } = containerRect;
  const {
    width,
    height,
    left,
    top
  } = popoverRect;
  let delta = 0;
  if (direction === 'right') {
    delta = containerWidth - left - width;
  }
  if (direction === 'bottom') {
    delta = containerHeight - top - height;
  }
  if (direction === 'top') {
    delta = top;
  }
  if (direction === 'left') {
    delta = left;
  }
  delta = delta < 0 ? 0 : delta;
  delta = delta > 24 ? 24 : delta;
  delta = delta === 0 ? delta : -Math.floor(delta);
  return delta;
};
const attachementSides = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left'
};
const getAttachmentSide = direction => attachementSides[direction];
export const setTouchzone = ({
  containerRect,
  popoverRect,
  direction
}) => {
  const touchzone = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  };
  const attachementSide = getAttachmentSide(direction);
  const sides = Object.keys(touchzone);
  sides.forEach(side => {
    touchzone[side] = side === attachementSide ? 0 : calcTouchzoneSide({
      containerRect,
      popoverRect,
      direction: side
    });
  });
  return touchzone;
};